const standardFontsSerif = [
	"Encode Sans",
	"-apple-system",
	"BlinkMacSystemFont",
	'"Segoe UI"',
	'"Helvetica Neue"',
	"Arial",
	"sans-serif",
	'"Apple Color Emoji"',
	'"Segoe UI Emoji"',
	'"Segoe UI Symbol"',
];
const standardFontsSans = [
	"Public Sans",
	"-apple-system",
	"BlinkMacSystemFont",
	'"Segoe UI"',
	'"Helvetica Neue"',
	"Arial",
	"sans-serif",
	'"Apple Color Emoji"',
	'"Segoe UI Emoji"',
	'"Segoe UI Symbol"',
];

const deepPurple = "#37236a";
const purple = "#6f3178";
const primary = deepPurple;
const secondary = purple;

const grey = {
	50: "#f9fbfd",
	100: "#f1f6fb",
	200: "#e9eff5",
	300: "#d8e2ec",
	400: "#b5bfc9",
	500: "#96a0aa",
	600: "#6d7781",
	700: "#59636d",
	800: "#333d47",
	900: "#19232d",
};

const palette = {
	body: {
		darker: "#212121",
	},
	purple: {
		main: purple,
		light: "#a05fae",
		dark: "#4a1852",
		contrastText: "#ffffff",
	},
	deepPurple: {
		main: deepPurple,
		light: "#5a3b8c",
		dark: "#24194a",
		contrastText: "#ffffff",
	},
	primary: {
		main: primary,
		light: "#5a3b8c",
		dark: "#24194a",
		contrastText: "#ffffff",
	},
	secondary: {
		main: secondary,
		light: "#a05fae",
		dark: "#4a1852",
		contrastText: "#ffffff",
	},
	closingHeadings: {
		main: primary,
		light: "#5a3b8c",
		dark: "#24194a",
		contrastText: "#ffffff",
	},
	subnav: {
		main: "#f9fbfd",
		contrastText: "#6d7781",
	},
	closingHeadingsSecond: {
		main: secondary,
		light: "#a05fae",
		dark: "#4a1852",
		contrastText: "#ffffff",
	},
	colophon: {
		main: "#19232d",
	},
	grey: {
		...grey,
		lighter: grey["100"],
		light: grey["200"],
		main: grey["200"],
		dark: grey["300"],
		darker: grey["400"],
		contrastText: "#000000",
	},
	dark: {
		main: grey["800"],
		light: grey["700"],
		dark: grey["900"],
		darker: grey["900"],
		contrastText: "#ffffff",
	},
	light: {
		main: grey["100"],
		light: grey["50"],
		dark: grey["200"],
		contrastText: "#000000",
	},
	link: {
		main: "#2196f3",
		light: "#52b2ff",
		dark: "#055fa6",
		hover: "#055fa6",
		contrastText: "#ffffff",
	},
	appBar: {
		public: {
			background: primary,
			main: primary,
			light: "#5a3b8c",
			dark: "#24194a",
			contrastText: "#ffffff",
			gradient: "linear-gradient(90deg, #37236a 29%, #6f3178)",
		},
		private: {
			background: "#ffffff",
			main: "#ffffff",
			light: grey["50"],
			dark: grey["200"],
			contrastText: primary,
		},
	},
	titleBar: {
		public: {
			background: secondary,
			main: secondary,
			light: "#a05fae",
			dark: "#4a1852",
			contrastText: "#ffffff",
			gradient: "url('/texture.png'), linear-gradient(90deg, #32006e, #76236c);",
		},
	},
	footer: {
		background: grey["800"],
		main: grey["800"],
		light: grey["700"],
		dark: grey["900"],
		contrastText: "#ffffff",
	},
	tab: {
		paper: "#e9eff5",
		main: "#e9eff5",
		hover: "#19232d",
		contrastText: "#19232d",
		contrastTextHover: "#e9eff5",
	},
};

const themeConfig = {
	components: {
		MuiButton: {
			styleOverrides: {
				contained: {
					fontWeight: 600,
				},
				text: {
					fontWeight: 600,
				},
			},
		},
	},
	cloverleaf: {
		googleFont: "Encode+Sans:wght@600&family=Public+Sans:wght@300;600",
		closingHeadingsStyled: true,
		navbar: {
			align: "left",
			layout: "bar",
			transparent: true,
			borderRadius: 9,
		},
		brand: {
			paddingTop: 2,
			paddingBottom: 0.5,
			size: 76,
			logoFooter: "/logo-footer.png",
		},
		footer: {
			useGrid: true,
			gridLayout: [2, 4, 3, 3, 2, 2, 2, 3, 3],
			gridCols: 12,
			socialLinksOnGrid: true,
			socialLinksJustify: "flex-end",
			socialLinksPosition: "after",
		},
		css: `
      .type-user .size-lg, [class^="page-our-people"] .pic-format-square{
          width: 200px !important;
          height: 280px !important;
      }

      #___gatsby .MuiAccordion-rounded ul{
          font-size: 0.9rem;
      }

      #___gatsby .entities-list .type-node--personnel .MuiAvatar-root{
          width: 200px;
          height: 280px;
      }
      #___gatsby .entities-list .type-node--personnel .excerpt-content {
          .excerpt-title{
              font-size: 1.1em;
              font-weight: 600;
              line-height: 1.5;
              small{ font-size: 1em; }
          }
          .subtitle{
              font-size: 0.7em;
              font-style: italic;
          }  
      }
      #___gatsby .closing-section .block-container.block-type-node--entities_list.full-width .MuiContainer-root {
        margin-top: 24px;
        margin-bottom: 24px;
      }
      #___gatsby .sidebar-blocks .image figure {
        border-radius: 3px;
      }
    `,
	},
	typography: {
		fontFamily: standardFontsSans.join(","),
		h1: {
			fontFamily: standardFontsSerif.join(","),
			fontWeight: 600,
		},
		h2: {
			fontFamily: standardFontsSerif.join(","),
		},
		h3: {
			fontFamily: standardFontsSans.join(","),
			fontWeight: 600,
		},
		h4: {
			fontFamily: standardFontsSans.join(","),
			fontWeight: 600,
		},
		h5: {
			fontFamily: standardFontsSans.join(","),
			fontWeight: 600,
		},
		h6: {
			fontFamily: standardFontsSans.join(","),
			fontWeight: 600,
		},
		brandTitle: {
			fontFamily: standardFontsSerif.join(","),
			fontWeight: 600,
		},
		toolsNav: {
			fontWeight: 600,
			fontFamily: standardFontsSans.join(","),
			textTransform: "uppercase",
			fontSize: "0.9rem",
		},
		nav: {
			fontWeight: 600,
			fontFamily: standardFontsSans.join(","),
			textTransform: "uppercase",
			fontSize: "1rem",
		},
		subnav: {
			textTransform: "none",
		},
	},
	palette: palette,
};
module.exports = themeConfig;
